/* eslint-disable jsx-a11y/anchor-is-valid,no-script-url */
import * as React from "react";
import { PropertyTabNames } from "./props";

export interface CustomProps {
  tabName: PropertyTabNames;
  tabChangeHandler: (tabName: PropertyTabNames) => void;
  shortlistedCount?: number;
}

const PropertyTabs: React.FunctionComponent<CustomProps> = (props) => {
  const [tabName, setTabName] = React.useState<PropertyTabNames>(
    props.tabName || PropertyTabNames.ShortListedProperties
  );
  const setElementActive = (tabValue: PropertyTabNames) => {
    setTabName(tabValue);
    props.tabChangeHandler(tabValue);
  };

  return (
    <ul
      className="nav tab-underline mb-3 border-bottom font-sm font-weight-semibold flex-nowrap text-nowrap mt-4 overflow-auto px-md-0 px-3 w-100 shortlist-tab"
      id="activity-tab"
      role="tablist"
    >
      <li className="nav-item" role="presentation">
        <a
          className={`cursor-pointer nav-link position-relative px-4 py-1 first border-right-0 border-bottom-0  ${
            tabName === PropertyTabNames.ShortListedProperties
              ? "active"
              : "text-gray-600"
          }`}
          onClick={(e) =>
            setElementActive(PropertyTabNames.ShortListedProperties)
          }
        >
          <span className=" py-1 d-inline-flex">
            Shortlisted Properties ({props.shortlistedCount || 0})
          </span>
        </a>
      </li>

      <li className="nav-item pr-4" role="presentation">
        <a
          className={`cursor-pointer nav-link position-relative px-4 py-1 f second border-bottom-0  ${
            tabName === PropertyTabNames.SearchProperties
              ? "active"
              : "text-gray-600"
          }`}
          onClick={(e) => setElementActive(PropertyTabNames.SearchProperties)}
        >
          <span className=" py-1 d-inline-flex">Search Properties</span>
        </a>
      </li>
    </ul>
  );
};

export default PropertyTabs;
